import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { useFormatNumber } from '../../../hooks/useFormatNumber';

interface MyTableCurrencyBanks {
    currency_id: number,
    currency_code: string,
    currency_description: string,
    balanceBankAccount: number,
    balanceAutorized: number,
    balanceFree: number,
    exchangeRate: number,
    active: boolean
}

export const useDialogCurrencyCompany= () => {
    const { setFormatNumberFromTable } = useFormatNumber();
    const { t } = useTranslation("global");

    const numberWithNotFormat = (value: string): number => {
        return parseFloat(value.replace(/[$,]/g, ''));
    }

    const columnsCurrency: GridColDef<MyTableCurrencyBanks>[] = [
        {
            field: 'currency_code', headerName: t("currencies.title-view"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                return <>
                    <Typography>
                        {params.value}
                    </Typography>
                </>
            }
        },
        {
            field: 'balanceBankAccount', headerName: t("payments.balance-table.balance"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                let value = params.value;
                if (typeof value === 'string')
                    value = numberWithNotFormat(value);
                return <>
                    <Typography sx={{ color: typeof value === 'number' && value < 0 ? 'red' : 'inherit', }}>
                        {setFormatNumberFromTable(params.value ?? 0)}
                    </Typography>
                </>
            },
        },
        {
            field: 'balanceAutorized', headerName: t("payments.balance-table.authorized"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                let value = params.value;
                if (typeof value === 'string')
                    value = numberWithNotFormat(value);
                return <>
                    <Typography sx={{ color: typeof value === 'number' && value < 0 ? 'red' : 'inherit', }}>
                        {setFormatNumberFromTable(params.value ?? 0)}
                    </Typography>
                </>
            },
        },
        {
            field: 'balanceFree', headerName: t("payments.balance-table.total_for_authorized"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                let value = params.value;
                if (typeof value === 'string')
                    value = numberWithNotFormat(value);
                return <>
                    <Typography sx={{ color: typeof value === 'number' && value < 0 ? 'red' : 'inherit', }}>
                        {setFormatNumberFromTable(params.value ?? 0)}
                    </Typography>
                </>
            },
        },
    ];

    return {
        columnsCurrency,
    }
}
